import axios from 'axios'

import { ensureCsrfToken } from '../../../../lib/csrf'

const BOARD_DECISIONS_URL = '/api/digital-risk/board-decisions/'

const mutationConfig = async () => ({
  withCredentials: true,
  headers: { 'X-CSRFToken': await ensureCsrfToken() },
})

const decisionUrl = (decisionReference) =>
  `${BOARD_DECISIONS_URL}${encodeURIComponent(decisionReference)}/`

export const fetchPendingBoardProposals = async () => {
  const { data } = await axios.get(`${BOARD_DECISIONS_URL}awaiting-proposals/`, { withCredentials: true })
  return data
}

export const fetchBoardInvestmentProposals = async () => {
  const { data } = await axios.get(`${BOARD_DECISIONS_URL}investment-proposals/`, { withCredentials: true })
  return data
}

export const fetchBoardInvestmentProposal = async (proposalReference) => {
  const { data } = await axios.get(`${BOARD_DECISIONS_URL}investment-proposals/${encodeURIComponent(proposalReference)}/`, { withCredentials: true })
  return data
}

export const fetchProgramReauthorizationBoardQueue = async () => {
  const { data } = await axios.get(`${BOARD_DECISIONS_URL}program-reauthorization-requests/`, { withCredentials: true })
  return data
}

export const fetchProgramReauthorizationBoardReview = async (requestReference) => {
  const { data } = await axios.get(`${BOARD_DECISIONS_URL}program-reauthorization-requests/${encodeURIComponent(requestReference)}/`, { withCredentials: true })
  return data
}

export const applyProgramReauthorizationAuthority = async (decisionReference) => {
  const { data } = await axios.post(
    `/api/digital-risk/investment-programs/reauthorizations/${encodeURIComponent(decisionReference)}/apply/`,
    {},
    await mutationConfig(),
  )
  return data
}

export const prepareProgramReauthorizationBoardDecision = async (requestReference) => {
  const { data } = await axios.post(`${BOARD_DECISIONS_URL}from-program-reauthorization-request/`, {
    program_reauthorization_request_reference: requestReference,
  }, await mutationConfig())
  return data
}

export const createPendingBoardDecision = async (payload) => {
  const { data } = await axios.post(BOARD_DECISIONS_URL, payload, await mutationConfig())
  return data
}

export const fetchBoardDecision = async (decisionReference) => {
  const { data } = await axios.get(decisionUrl(decisionReference), { withCredentials: true })
  return data
}

export const recordBoardDecision = async ({ decisionReference, payload }) => {
  const { data } = await axios.post(`${decisionUrl(decisionReference)}record/`, payload, await mutationConfig())
  return data
}

export const supersedeBoardDecision = async ({ decisionReference, payload }) => {
  const { data } = await axios.post(`${decisionUrl(decisionReference)}supersede/`, payload, await mutationConfig())
  return data
}

export const publishBoardAnalyticalEvidence = async (decisionReference) => {
  const { data } = await axios.post('/api/digital-risk/dashboard/publish-portfolio-snapshot/', { board_decision_reference: decisionReference }, await mutationConfig())
  return data
}
export const approveBoardAnalyticalEvidence = async (snapshotId) => {
  const { data } = await axios.post(`/api/digital-risk/dashboard/approve-portfolio-snapshot/${snapshotId}/`, { comments: 'Board-authorized portfolio analytical validation.' }, await mutationConfig())
  return data
}
export const linkBoardAnalyticalEvidence = async (decisionReference, snapshotId) => {
  const { data } = await axios.post(`${decisionUrl(decisionReference)}analytical-evidence/`, { portfolio_snapshot_id: snapshotId }, await mutationConfig())
  return data
}
